module.exports = __webpack_public_path__ + "media/images/black_history_month/bg-shape-ladyfinger-925e8f6ffedda0e410ad6c525b167d65.svg";